import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { APP_CONFIG } from '../../../configs/app-config.constants';
import { InterfaceAppConfig } from '../../../configs/app-interface.config';

@Injectable({
    providedIn: 'root',
})
export class GyanOrganisationService {
    url: any;
    domainUrl = environment.gyanApiUrl;

    constructor(
        private http: HttpClient,
        @Inject(APP_CONFIG)
        private config: InterfaceAppConfig,
    ) {}

    getMyTopicDetails(reqBody: any): Observable<any> {
        const url = this.domainUrl + this.config.apis.gyan.organisation.topicDetails;
        return this.http.post(url, reqBody);
    }

    getFindByName(reqBody: any): Observable<any> {
        const url = this.domainUrl + this.config.apis.gyan.organisation.searchtopicbyname;
        return this.http.post(url, reqBody);
    }

    createFolderByName(reqBody: { folderName: null; parentFolderId: null }): Observable<any> {
        const url = this.domainUrl + this.config.apis.gyan.organisation.createfolderbyname;
        return this.http.post(url, reqBody);
    }
}
